







import {Component, Vue, Inject, Emit, Prop} from "vue-property-decorator";
import Antd from "ant-design-vue";
import AbpBase from "@/lib/abpbase";
import _ from "lodash";
import {API_ChangePassword, API_GetSmsCaptcha, API_Register} from "@/api/login";
import ajaxHelperInstance from "@/lib/ajaxhelper";
import utcClockProvider = abp.timing.utcClockProvider;
import util from "@/lib/util";
import Util from "@/lib/util";

const formItemLayout = {
    labelCol: {span: 6},
    wrapperCol: {span: 18},
};

@Component({
    components: {}
})
export default class wxRedirect extends AbpBase {

    needRegister: boolean = false;

    loadToken(code, state) {
        let self = this;
        if (code == null || state == null) {
            this.needRegister = true;
            return;
        }

        ajaxHelperInstance.get('/web/auth/loginWx', {
            code: code,
            state: state
        }).then((res) => {
            let {data, errno, message} = res.data;
            let routerPs:any = {
                name: 'login',
                params: {
                    'isWx': '1'
                }
            };
            if (errno != 0) {
                routerPs.params = {};
                this.$router.push(routerPs);
            }
            let status = data.status;
            if (status == 0) {
                this.$router.push(routerPs);
            } else {
                Util.abp.auth.setToken(data.access_token);
                location.reload();
            }
        })

    }

    mounted() {
        let code = util.getUrlParam('code');
        let state = util.getUrlParam('state');
        this.loadToken(code, state);
    }
}
